module.exports = __webpack_public_path__ + "img/9D7F6E_C6DAD4_6D4C4B_C6BBBC-256px.87c0aaf7.png";